import { createReducer, on, createFeatureSelector, createSelector } from '@ngrx/store';
import { Pagination } from '../models/pagination.model';
import { Profile } from '../models/profile.model';
import { setProfiles } from '../actions/profiles.actions';

export const initialState: Pagination<Profile> = null;

const reducer = createReducer(initialState,
  on(setProfiles, (state, profiles) => profiles)
);

export const fromProfiles = {
  selectProfilesState: createFeatureSelector<Pagination<Profile>>('profiles'),

  selectProfilesByJobtype: (jobtypeId: number) => createSelector(
    (state: { profiles: Pagination<Profile> }) => state.profiles,
    (profiles: Pagination<Profile>) => ({ ...profiles, data: profiles.data.filter(profile => profile.jobtypeId === jobtypeId) })
  ),
};

export function profilesReducer(state, action) {
  return reducer(state, action);
}
